import dayjs from 'dayjs';
import { SHARED_ESPN_CONFIG } from '../../shared';

type RegionKey = keyof typeof SHARED_ESPN_CONFIG.regionOffsets;

const HHMM = 'HH:mm';
const fmt = (d: dayjs.Dayjs) => d.format(HHMM);

const recomputeTimesFromBase = (baseHHMM: string, data: Record<string, any>) => {
  const base = dayjs(baseHHMM, HHMM);
  const out: Record<string, string> = {};
  const OFF = SHARED_ESPN_CONFIG.regionOffsets;

  if (data.region2) out.time2 = fmt(base.add(OFF[data.region2 as RegionKey] ?? 0, 'hour'));
  if (data.region3) out.time3 = fmt(base.add(OFF[data.region3 as RegionKey] ?? 0, 'hour'));
  if (data.region4) out.time4 = fmt(base.add(OFF[data.region4 as RegionKey] ?? 0, 'hour'));
  return out;
};

const computeSingleTime = (baseTime: string, regionOffset: number): string => {
  const base = dayjs(baseTime, HHMM);
  return fmt(base.add(regionOffset, 'hour'));
};

const applyESPNDynamicOptions = (fieldKey: string, value: any, formData: Record<string, any>) => {
  const updates: Record<string, any> = {};

  if (fieldKey === 'sport') {
    updates.league = '';
    updates.team1 = '';
    updates.team2 = '';
    updates.tournament = '';
  }

  return updates;
};

interface ESPNFormData {
  sport: string;
  league: string;
  [key: string]: any;
}

export const buildESPNBannerType = (formData: Partial<ESPNFormData>): string => {
  const { sport, league } = formData;

  if (!sport || !league) return 'espn/espn-vs';

  let path = `espn/espn-vs/${sport}/${league}/vertical`;

  return path;
};

export const applyESPNLogic = (fieldKey: string, value: any, formData: Record<string, any>): Record<string, any> => {
  const updates: Record<string, any> = {};

  Object.assign(updates, applyESPNDynamicOptions(fieldKey, value, formData));

  // AutoSync activado con time1
  if (fieldKey === 'autoSyncTimes' && value && formData.time1) {
    Object.assign(updates, recomputeTimesFromBase(formData.time1, formData));
  }

  // Desactivar región 4
  if (fieldKey === 'enableRegion4' && !value) {
    updates.region4 = undefined;
    updates.time4 = undefined;
  }

  // Cambio de time1 con autoSync activo
  if (formData.autoSyncTimes && fieldKey === 'time1' && value) {
    Object.assign(updates, recomputeTimesFromBase(value, formData));
  }

  // Cambio de región con autoSync activo
  if (
    formData.autoSyncTimes &&
    formData.time1 &&
    (fieldKey === 'region2' || fieldKey === 'region3' || fieldKey === 'region4')
  ) {
    const keyToTime = fieldKey.replace('region', 'time') as 'time2' | 'time3' | 'time4';
    const offset = SHARED_ESPN_CONFIG.regionOffsets[value as RegionKey] ?? 0;
    updates[keyToTime] = computeSingleTime(formData.time1, offset);
  }

  return updates;
};
